<template>
   <question-wrapper :questionId="questionId">
        <question-header :title="title" />
        <question-text :explainer="explainer" :pass="pass" :fail="fail" :skip="skip" :callToAction="callToAction" v-on:doTest="testCam" />

        <!--<div class="skip" v-if="!pass && !skip && !fail">-->
          <!--<p class="skip-note">-->
            <!--<translate>If you do not have a camera and still want to participate in the class, you can</translate>-->
            <!--<a href="#" class="btn btn-warning btn-embossed skip-camera-test" v-on:click="skipCameraTest">-->
              <!--<translate>Skip this Test &gt;&gt;</translate>-->
            <!--</a>-->
          <!--</p>-->
        <!--</div>-->

        <div class="result">
          <!-- Pass -->
        	<pass-message :pass="pass" :skip="skip" :nextPage="nextPage" :previousPage="previousPage">
            <div slot="message">
              <p v-if="pass">
                <translate>Brilliant! You have a working camera and have allowed access to it.</translate>
                <br>
                <translate>One test to go...</translate>
              </p>
              <p v-if="skip">
                <translate>Camera test skipped.</translate>&nbsp;
                <translate>You will be attending the class in audio only mode.</translate>
              </p>
            </div>
          </pass-message>

			  <!-- Fail -->
          <camera-fail
            v-if="fail"
            :usersBrowserName="usersBrowserName"
            :usersBrowserVersion="usersBrowserVersion"
            :permissionProblem="camInstalled"
            :hardwareProblem="!camInstalled"
            @skipTest="skipCameraTest"
          />

        </div>
  	</question-wrapper>
</template>

<script>
	import BasePage from './common/BasePage.vue'
	import {mapState, mapMutations} from 'vuex'
  import CameraFail from '@/../../shared/src/components/usersetup/CameraFail.vue'
  /**
  * This is the _*page*_ component that holds all the components and data necessary for testing whether the user has a working camera
  * Like all pages it has a header, an explanation of the test, a button to execute the test and messages to display when the test is complete
  */
	export default {

		name: 'Camera',
    mixins: [BasePage],

    components: {
		  CameraFail
    },

		data () {
			return {
        vuexModule: 'camera'
      }
		},

		computed: {

			...mapState('camera', [
				'camInstalled'
			])

		},

		methods: {

		  ...mapMutations('camera', ['isCamInstalled', 'disableCam']),

      /**
      * _*Listens*_ to the custom _doTest_ event fired by the Question component and executes the _testCam()_ method callback
      * @event doTest
      * @type {Event}
      */
      testCam () {
        navigator.mediaDevices.getUserMedia({ audio: false, video: true })
        .then(result => {
          this.passTest()
        })
        .catch(error => {
          this.failHandler(error)
        })
      },

      skipCameraTest (e) {
        if (e && e.preventDefault) {
          e.preventDefault()
        }
        const skipPayload = this.statusMessage({
          'desc': 'User skipped the camera test',
          'status': 'skip'
        })
        this.skipTest(skipPayload)
        this.disableCam()
      },

      failHandler (error) {
        let description = ''
        if (window.DetectRTC.hasWebcam) {
          description = 'User has NOT granted access to camera'
          this.isCamInstalled()
        } else {
          description = 'Camera is not installed or can not be detected'
        }
        const failPayload = this.statusMessage({'desc': description}, error)
        this.failTest(failPayload)
      }
		}
	}

</script>

<style scoped>

</style>
